<div *ngIf="uValutuDokumenta; else izStraneValute" class="p-d-flex p-flex-column gap-6">
  <div *ngIf="jeKursDokumentaDostupan; else kursNijeDostupan" class="field-radiobutton p-d-flex p-ai-start">
    <p-radioButton
      [name]="'konverzija-' + rowId"
      value="srednji"
      [(ngModel)]="nacinKonverzije"
      [inputId]="'konverzija-srednji-' + rowId"
      (ngModelChange)="handleNacinKonverzijeChange()"
    ></p-radioButton>
    <label [for]="'konverzija-srednji-' + rowId" class="p-ml-3"
      >srednji (1 {{ valutaDokumenta }} = {{ kursDokumenta | number : '1.4-4' }} RSD) =
      {{ iznosUValutiDokumenta | currencyNumber : valutaDokumenta }}</label
    >
  </div>
  <ng-template #kursNijeDostupan>
    <small class="p-error"
      >Srednji kurs NBS za {{ valutaDokumenta }} nije dostupan. Unesite iznos
      ručno.</small
    >
  </ng-template>
  <div class="field-radiobutton p-d-flex p-ai-center">
    <p-radioButton
      [name]="'konverzija-' + rowId"
      value="rucno"
      [(ngModel)]="nacinKonverzije"
      [inputId]="'konverzija-rucno-' + rowId"
      [disabled]="!jeKursDokumentaDostupan"
      (ngModelChange)="handleNacinKonverzijeChange()"
    ></p-radioButton>
    <label [for]="'konverzija-rucno-' + rowId" class="p-ml-3 p-mr-2">ručno:</label>
    <p-inputNumber
      [ngModel]="rucniIznos"
      (ngModelChange)="handleRucniIznosChange($event)"
      [size]="6"
      mode="decimal"
      [minFractionDigits]="2"
      [maxFractionDigits]="2"
    ></p-inputNumber>
    <span class="p-ml-2">{{ valutaDokumenta }}</span>
  </div>
</div>

<ng-template #izStraneValute>
<div class="p-d-flex p-flex-column gap-6">
  <div class="field-radiobutton p-d-flex p-ai-start">
    <p-radioButton
      [name]="'kurs-' + rowId"
      [value]="iznosPoSrednjemKursu"
      [(ngModel)]="odabraniKurs"
      inputId="srednji"
      (ngModelChange)="handleChange($event)"
    ></p-radioButton>
    <label for="srednji" class="p-ml-3"
      >srednji = {{ iznosPoSrednjemKursu | currencyNumber }}</label
    >
  </div>
  <div class="field-radiobutton p-d-flex p-ai-start">
    <p-radioButton
      [name]="'kurs-' + rowId"
      [value]="iznosPoProdajnomKursu"
      [(ngModel)]="odabraniKurs"
      inputId="prodajni"
      (ngModelChange)="handleChange($event)"
    ></p-radioButton>
    <label for="prodajni" class="p-ml-3"
      >prodajni = {{ iznosPoProdajnomKursu | currencyNumber }}</label
    >
  </div>
<kodit-divider></kodit-divider>
  <div class="field-radiobutton p-d-flex p-ai-start">
    <p-radioButton
      [name]="'kurs-' + rowId"
      [value]="iznosUStranojValuti"
      [(ngModel)]="odabraniKurs"
      inputId="iznos-u-stranoj-valuti"
      (ngModelChange)="handleChange($event)"
    ></p-radioButton>
    <label for="iznos-u-stranoj-valuti" class="p-ml-3"
      >Iznos iz cenovnika: {{ iznosUStranojValuti | currencyNumber : valutaText}}</label
    >
  </div>
</div>
</ng-template>
